import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class NotificationJobsHelper  {
    _originalTypeClassName = "zPMO.BO.NotificationJobsHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
NotificationJobsHelper.translate = translateService;
}
this.NotificationJobsHelperKey = null;
this._key = this.NotificationJobsHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _NotificationJobsHelperKey:any;
get NotificationJobsHelperKey(): any {
    return this._NotificationJobsHelperKey;
  }
set NotificationJobsHelperKey(value: any) {
    this._NotificationJobsHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.NotificationJobsHelperKey == null || $this.NotificationJobsHelperKey == 0;
            }


}